import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const resignationSetting = (state = initialState.resignationSettings, action) => {
  switch (action.type) {
    case types.FETCH_RESIGNATION_SETTINGS_SUCCESS:
      return { ...state, resignationSettings: action.payload }
    case types.FETCH_RESIGNATION_SETTINGS_FAILURE:
      return state
    case types.FETCH_RESIGNATION_SETTING_SUCCESS:
      return { ...state, resignationSetting: action.payload }
    case types.FETCH_RESIGNATION_SETTING_FAILURE:
      return state
    case types.CREATE_RESIGNATION_SETTINGS_SUCCESS:
      return { ...state, resignationSettings: [...state.resignationSettings, action.payload] }
    case types.CREATE_RESIGNATION_SETTINGS_FAILURE:
      return state
    case types.UPDATE_RESIGNATION_SETTING_SUCCESS:
      return {
        ...state,
        resignationSettings: [...state.resignationSettings, action.payload]
      }
    case types.UPDATE_RESIGNATION_SETTING_FAILURE:
      return state
    default:
      return state
  }
}
